import _definePage_default_0 from '/app/frontend/src/pages/upgrade-draft-study/[trialId].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/create-draft-study',
    /* internal name: '/create-draft-study' */
    /* no component */
    children: [
      {
        path: '',
        name: '/create-draft-study/',
        component: () => import('/app/frontend/src/pages/create-draft-study/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/create-study',
    /* internal name: '/create-study' */
    /* no component */
    children: [
      {
        path: ':trialId',
        name: '/create-study/[trialId]',
        component: () => import('/app/frontend/src/pages/create-study/[trialId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/edit-draft-study',
    /* internal name: '/edit-draft-study' */
    /* no component */
    children: [
      {
        path: ':trialId',
        name: '/edit-draft-study/[trialId]',
        component: () => import('/app/frontend/src/pages/edit-draft-study/[trialId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/edit-study',
    /* internal name: '/edit-study' */
    /* no component */
    children: [
      {
        path: ':trialId',
        name: '/edit-study/[trialId]',
        component: () => import('/app/frontend/src/pages/edit-study/[trialId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/study',
    /* internal name: '/study' */
    /* no component */
    children: [
      {
        path: ':studyId',
        /* internal name: '/study/[studyId]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/study/[studyId]/',
            component: () => import('/app/frontend/src/pages/study/[studyId]/index.vue'),
            /* no children */
          },
          {
            path: 'country',
            /* internal name: '/study/[studyId]/country' */
            /* no component */
            children: [
              {
                path: ':countryId',
                name: '/study/[studyId]/country/[countryId]',
                component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId].vue'),
                children: [
                  {
                    path: '',
                    name: '/study/[studyId]/country/[countryId]/',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'activation-rate',
                    name: '/study/[studyId]/country/[countryId]/activation-rate',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/activation-rate.vue'),
                    /* no children */
                  },
                  {
                    path: 'recruitment-rate',
                    name: '/study/[studyId]/country/[countryId]/recruitment-rate',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/recruitment-rate.vue'),
                    /* no children */
                  },
                  {
                    path: 'retention-rate',
                    name: '/study/[studyId]/country/[countryId]/retention-rate',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/retention-rate.vue'),
                    /* no children */
                  },
                  {
                    path: 'similar-trials',
                    name: '/study/[studyId]/country/[countryId]/similar-trials',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/similar-trials.vue'),
                    /* no children */
                  },
                  {
                    path: 'site-experience',
                    name: '/study/[studyId]/country/[countryId]/site-experience',
                    component: () => import('/app/frontend/src/pages/study/[studyId]/country/[countryId]/site-experience.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'scenario',
            /* internal name: '/study/[studyId]/scenario' */
            /* no component */
            children: [
              {
                path: ':scenarioId/:mode',
                name: '/study/[studyId]/scenario/[scenarioId].[mode]',
                component: () => import('/app/frontend/src/pages/study/[studyId]/scenario/[scenarioId].[mode].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'similar-trials',
            name: '/study/[studyId]/similar-trials',
            component: () => import('/app/frontend/src/pages/study/[studyId]/similar-trials.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/tper',
    /* internal name: '/tper' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tper/',
        component: () => import('/app/frontend/src/pages/tper/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/upgrade-draft-study',
    /* internal name: '/upgrade-draft-study' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':trialId',
          name: '/upgrade-draft-study/[trialId]',
          component: () => import('/app/frontend/src/pages/upgrade-draft-study/[trialId].vue'),
          /* no children */
        },
        _definePage_default_0
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

